import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import memoize from 'lodash.memoize';

const getTransaction = (state) => resolveProp('entities.transactions.byId', state) || {};

// @TODO reduceify
export default createSelector(getTransaction, (transactions) =>
    memoize((transactionId) => {
        const account = transactions[transactionId];

        const groupByMonth = {};

        account.transactions.forEach((transaction) => {
            if (!groupByMonth[transaction.month]) {
                groupByMonth[transaction.month] = {
                    timestamp: transaction.month,
                    balance: transaction.balance,
                    debited: 0,
                    credited: 0,
                };
            }
            groupByMonth[transaction.month].debited += transaction.debit;
            groupByMonth[transaction.month].credited += transaction.credit;
        });

        return Object.keys(groupByMonth).map((key) => groupByMonth[key]);
    }),
);
